import Divider from '@mui/material/Divider'
import { Grid2Props } from '@mui/material/Grid2'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { MoovyAction, MoovyResource } from '../../app/permissions'

import Grid from '@mui/material/Grid2'
import React from 'react'
import MoovyRestricted from '../moovyRestricted'

export interface MoovyContainerSubHeaderProps {
  title?: React.ReactNode | string
  description?: React.ReactNode | string
  button?: React.ReactNode
  alignGridItems?: 'center' | 'flex-start' | 'flex-end'
  divider?: boolean
  props?: Grid2Props
  titleProps?: Grid2Props
  action?: MoovyAction
  resource?: MoovyResource
}

const MoovyContainerSubHeader: React.FC<MoovyContainerSubHeaderProps> = ({
  action,
  resource,
  title,
  description,
  button,
  alignGridItems,
  divider,
  props,
  titleProps,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const Render = () => (
    <Grid>
      <Grid container direction="row" alignItems={'center'} p={2} {...props}>
        <Grid
          container
          size={12}
          direction="row"
          alignItems={alignGridItems || 'center'}
          gap={isMobile && description ? 1 : 0}
        >
          <Grid size={{ xs: description ? 12 : 8, md: 8 }} {...titleProps}>
            {/*TODO Antti: h3 style should be commonly defined as well as other header styles like h1 and h2*/}
            <h3 style={{ padding: 0, margin: 0, lineHeight: '120%' }}>
              {title}
            </h3>
          </Grid>
          {description && <Grid size={{ xs: 12, md: 8 }}>{description}</Grid>}
          <Grid
            container
            size={{ md: 4, xs: description ? 12 : 4 }}
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-end',
            }}
          >
            <>{button}</>
          </Grid>
        </Grid>
      </Grid>
      {divider && (
        <Grid size={12} pb={2}>
          <Divider />
        </Grid>
      )}
    </Grid>
  )

  return (
    <>
      {action && resource ? (
        <MoovyRestricted action={action} resource={resource}>
          <Render />
        </MoovyRestricted>
      ) : (
        <Render />
      )}
    </>
  )
}

export default MoovyContainerSubHeader
